import { createAction, props } from '@ngrx/store';
import { Company } from '../../models/dbmodels';

export const loadAllCompanies = createAction(
  '[Companies] Load All Companies'
);

export const loadCompaniesSuccess = createAction(
  '[Companies] Load Companies Success',
  props<{ companies: Company[] }>()
);

export const loadCompaniesFailure = createAction(
  '[Companies] Load Companies Failure',
  props<{ error: Error }>()
);
